import { ButtonHTMLAttributes } from 'react'

import { formatValue, UnitType } from '../utils/allocation'

interface StepButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'type'> {
  type: 'minus' | 'plus'
  disabled: boolean
  onClick: () => void
  ariaLabel: string
  stepIncrement?: number
  unitType?: UnitType
}

const StepButton = ({
  type,
  disabled,
  onClick,
  ariaLabel,
  stepIncrement = 1,
  unitType = 'none',
  ...rest
}: StepButtonProps) => {
  const showStep = stepIncrement !== 1
  const symbol = type === 'minus' ? '−' : '+'
  const label = showStep
    ? `${symbol}${formatValue(stepIncrement, unitType)}`
    : symbol

  return (
    <button
      aria-disabled={disabled}
      aria-label={ariaLabel}
      className={`flex h-10 items-center justify-center rounded-lg border-2 border-gray-600 bg-white text-gray-700 shadow-sm transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:border-gray-400 disabled:bg-gray-100 disabled:text-gray-400 ${showStep ? 'min-w-[3.5rem] px-2' : 'w-10'}`}
      disabled={disabled}
      onClick={onClick}
      type="button"
      {...rest}
    >
      <span
        className={`font-semibold leading-none ${showStep ? 'text-sm' : 'text-xl'}`}
      >
        {label}
      </span>
    </button>
  )
}

export default StepButton
